import React, { useEffect, useState } from "react";
//internal and external components and containers import
import { Box, Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { SwitchButton } from "../../components/SwitchButton";
import ActionsTable from "../../components/ActionsTable";
import { useDispatch, useSelector } from "react-redux";
import { getStandrdsActions, saveEvaluationReportStandardDetails } from "../../api/evaluation";
import {
  setActionsList,
  setCriteriaActions,
  setDepartmentList,
  setProjectList,
  setStaffList,
} from "../../redux/reducers/evaluation";
import { deleteAction, getAllActions, updateActions } from "../../api/action";
import { getStaff } from "../../api/user";
import { getClubDepartments, getProjectsByClub } from "../../api/club";
import { setLicenceCriteriaActions } from "../../redux/reducers/licence";
import {
  getLicenceStandardsAction,
  updateActionsLicence,
} from "../../api/licence";
import { useTranslation } from "react-i18next";
import { setSnackBarData } from "../../redux/reducers/common";
import { useLocation } from "react-router";
import './styles.css';

export const Actions = (props: any) => {
  const { isOpen, module } = props;
  const [t] = useTranslation();
  const location = useLocation();
  const [showAllctions, setShowAllActions] = React.useState(false);
  const [addAction, setAddAction] = React.useState(false);
  const [isFetchingActions, setIsFetchingActions] = React.useState(false);
  const [isAddAcionLoad, setIsAddAcionLoad] = useState(false);
  const isAdmin = useSelector((state: any) => state.common.isAdmin);
  const currentEvalCriteria = useSelector(
    (state: any) => state.evaluation.selectedSaCriteria
  );
  const selectedLicenceCriteria = useSelector(
    (state: any) => state.licence.selectedLicenceCriteria
  );
  const currentClub = useSelector((state: any) => state.clubDetails);
  const criteriaActions = useSelector(
    (state: any) => state.evaluation.saCriteriaActions
  );
  const licenceCriteriaActions = useSelector(
    (state: any) => state.licence.criteriaActions
  );
  const dispatch = useDispatch();
  const [actionList, setActionList] = useState(() => {
    if (module == t("EVALUATION")) {
      return criteriaActions;
    } else if (module == "licence") {
      return licenceCriteriaActions;
    } else return [];
  });
  const [selectedCriteria, setSelectedCriteria] = useState({});

  const initialAdminAction = {
    name: "",
    description: "",
    isCreatedByJL: true,
    isArchived: false,
    isAlreadyComplete: false,
    licenceJLActionStatus: false,
    ragb: 4,
  };

  const tableHead = [
    {
      key: "",
      displayName: "",
    },
    {
      key: "status",
      displayName: "status",
    },
    {
      key: "actionComment",
      displayName: "action",
    },
    {
      key: "description",
      displayName: "description",
    },
    {
      key: "standardsId",
      displayName: "standard",
    },
    {
      key: "dueDate",
      displayName: "due date",
    },
    {
      key: "owner",
      displayName: "owner",
    },
    {
      key: "department",
      displayName: "department",
    },
    {
      key: "project",
      displayName: "project",
    },
    {
      key: "",
      displayName: "",
    },
  ];

  const fetchActions = async () => {
    switch (module) {
      case t("EVALUATION"):
        const evalRes = await getStandrdsActions({
          standardId: 0,
          clubId: currentClub.id,
          criteriaId: currentEvalCriteria.id,
        });
        dispatch(setCriteriaActions(evalRes));
        setActionList(evalRes);
        break;
      case "licence":
        const licenceRes = await getLicenceStandardsAction({
          standardId: 0,
          clubId: currentClub.id,
          criteriaId: selectedLicenceCriteria.id,
        });
        dispatch(setLicenceCriteriaActions(licenceRes));
        setActionList(licenceRes);
        break;
    }
    setIsFetchingActions(false);
  };

  useEffect(() => {
    if (isOpen) {
      setIsFetchingActions(true);
      fetchActions();
    }

    switch (module) {
      case t("EVALUATION"):
        setSelectedCriteria(currentEvalCriteria);
        break;
      case "licece":
        setSelectedCriteria(selectedLicenceCriteria);
        break;
    }
  }, [currentEvalCriteria, selectedLicenceCriteria, isOpen, module]);

  const manageAddAction = () => {
    const fetchActionList = async () => {
      setIsAddAcionLoad(true);
      const response = await getStandrdsActions({
        standardId: 0,
        clubId: currentClub.id,
        criteriaId: currentEvalCriteria.id,
      });
      return response;
    };
    const fetchStaffList = async () => {
      const response = await getStaff({ clubId: currentClub.id });
      return response;
    };
    const fetchClubProject = async () => {
      const response = await getProjectsByClub({ clubId: currentClub.id });
      return response;
    };
    const fetchDepartments = async () => {
      const response = await getClubDepartments({ clubId: currentClub.id });
      return response;
    };

    if (currentClub?.id) {
      fetchActionList().then((res) => {
        dispatch(setActionsList(res));
      });
      fetchStaffList().then((res) => {
        dispatch(setStaffList(res));
      });
      fetchClubProject().then((res) => {
        dispatch(setProjectList(res));
        setIsAddAcionLoad(false);
      });
      currentClub.id &&
        fetchDepartments().then((res: any) => {
          dispatch(setDepartmentList(res));
        });
    }
    setAddAction(true);
  };

  const updateState = (updatedData: any) => {
    switch (module) {
      case t("EVALUATION"):
        dispatch(setCriteriaActions(updatedData));
        break;
      case "licence":
        dispatch(setLicenceCriteriaActions(updatedData));
        break;
    }
  };

  const manageCRUDMethod = async (type: string, dataToUpdate?: any) => {
    switch (type + "_" + module) {
      // CRUD for criteria evaluation actions
      case `create_${t("EVALUATION")}`:
        setAddAction(false);
        setActionList([dataToUpdate, ...actionList]);
        var newActionWithId: any = [];
        for (var i = 0; i < dataToUpdate?.standardHistory?.length; i++) {
          var newStandardId = dataToUpdate?.standardHistory[i]?.id;
          // eslint-disable-next-line no-loop-func
          var tempActionArr = actionList.filter((actionItem: any) => {
            return actionItem?.standardHistory.some(
              (sh: any) => sh.standardId == newStandardId
            );
          });
          if (i == 0) {
            tempActionArr = [...tempActionArr, dataToUpdate];
          } else {
            tempActionArr = [...tempActionArr, newActionWithId];
          }
          var actionParams = {
            clubId: currentClub?.id,
            standardId: newStandardId,
            actions: tempActionArr,
          };
          // eslint-disable-next-line no-loop-func
          await updateActions(actionParams).then((res: any) => {
            if (res !== undefined && Array.isArray(res) && res.length > 0 && i == 0) {
              newActionWithId = res[0];
            }
            if (
              i == dataToUpdate?.standardHistory?.length - 1 &&
              res !== undefined &&
              Array.isArray(res) &&
              res.length > 0
            ) {
              const warningData: any = {
                isOpen: true,
                severity: "success",
                message: t("ACTION_CREATED_SUCCESSFULLY"),
              };
              dispatch(setSnackBarData(warningData));
            } else if (
              !(res !== undefined && Array.isArray(res) && res.length > 0)
            ) {
              const warningData: any = {
                isOpen: true,
                severity: "error",
                message: t("ERROR_IN_CREATING_ACTION"),
              };
              dispatch(setSnackBarData(warningData));
            }
          });
        }
        fetchActions();
        break;

      case `delete_${t("EVALUATION")}`:
        var tempArrDelete = actionList.filter(
          (actionItem: any) => actionItem.id !== dataToUpdate
        );
        setActionList(tempArrDelete);
        break;

      case `archive_${t("EVALUATION")}`:
        var tempArrArchive = actionList.filter(
          (actionItem: any) => actionItem.id !== dataToUpdate
        );
        setActionList(tempArrArchive);
        break;

      case `update_${t("EVALUATION")}`:
        var tempArrUpdate = actionList.map((actionItem: any) =>
          actionItem.id == dataToUpdate?.id ? dataToUpdate : actionItem
        );
        setActionList(tempArrUpdate);
        // if(isAdmin) {
        // const updateParameters = {
        //   clubId: currentClub?.id,
        //   actions: tempArrUpdate,
        //   standardId: standard?.id,
        // };
        // updateActionsLicence(updateParameters).then((res: any) => {
        //   dispatch(setLicenceStandardsActions(res));
        //   const warningData: any = {
        //     isOpen: true,
        //     severity: "success",
        //     message: t("ACTION_UPDATED_SUCCESSFULLY"),
        //   };
        //   dispatch(setSnackBarData(warningData));
        // });
        // }
        break;

      // CRUD for criteria licence actions
      case `create_licence`:
        setAddAction(false);
        setActionList([
          {
            ...dataToUpdate,
            licenceStandardHistory: dataToUpdate.standardHistory,
          },
          ...actionList,
        ]);
        var actionArrL: any = [];
        for (var il = 0; il < dataToUpdate?.standardHistory?.length; il++) {
          var newStandardIdL = dataToUpdate?.standardHistory[il]?.id;
          // eslint-disable-next-line no-loop-func
          var tempActionArrL = actionList.filter((actionItem: any) => {
            return actionItem?.standardHistory?.some(
              (sh: any) => sh.standardId == newStandardIdL
            );
          });
          if (il == 0) {
            actionArrL = [...tempActionArrL, dataToUpdate];
          } else {
            actionArrL = [...tempActionArrL, ...actionArrL];
          }
          var actionParamsL = {
            clubId: currentClub?.id,
            standardId: newStandardIdL,
            actions: actionArrL,
          };
          // eslint-disable-next-line no-loop-func
          await updateActionsLicence(actionParamsL).then((res: any) => {
            if (res !== undefined && Array.isArray(res) && res.length > 0) {
              actionArrL = [res[0]];
            }
            if (
              i == dataToUpdate?.standardHistory?.length - 1 &&
              res !== undefined &&
              Array.isArray(res) &&
              res.length > 0
            ) {
              const warningData: any = {
                isOpen: true,
                severity: "success",
                message: t("ACTION_CREATED_SUCCESSFULLY"),
              };
              dispatch(setSnackBarData(warningData));
            } else if (
              !(res !== undefined && Array.isArray(res) && res.length > 0)
            ) {
              const warningData: any = {
                isOpen: true,
                severity: "error",
                message: t("ERROR_IN_CREATING_ACTION"),
              };
              dispatch(setSnackBarData(warningData));
              setActionList([...actionList]);
            }
          });
        }
        fetchActions();
        break;

      case `delete_licence`:
        var tempArrDeleteL = actionList.filter(
          (actionItem: any) => actionItem.id !== dataToUpdate
        );
        setActionList(tempArrDeleteL);
        break;

      case `archive_licence`:
        var tempArrArchiveL = actionList.filter(
          (actionItem: any) => actionItem.id !== dataToUpdate
        );
        setActionList(tempArrArchiveL);
        break;

      case `update_licence`:
        var tempArrUpdateL = actionList.map((actionItem: any) =>
          actionItem.id == dataToUpdate?.id ? dataToUpdate : actionItem
        );
        setActionList(tempArrUpdateL);
        break;
      
      case "issue_unissue_licence":
        let issueUnIssueTempArr: any = actionList.map((obj: any) => {
          if (obj.id == dataToUpdate?.id || !("id" in dataToUpdate)) {
            return {
              ...obj,
              licenceJLActionStatus: !obj.licenceJLActionStatus,
            };
          }
          return obj;
        });
        setActionList(issueUnIssueTempArr);
        // const issueUnIssueParameters = {
        //   clubId: currentClub.id,
        //   actions: issueUnIssueTempArr,
        //   standardId: standard.id,
        // };
        // updateActionsLicence(issueUnIssueParameters).then((res: any) => {
        //   setActionList(res);
        //   const warningData: any = {
        //     isOpen: true,
        //     severity: "success",
        //     message: t("ACTION_UPDATED_SUCCESSFULLY"),
        //   };
        //   dispatch(setSnackBarData(warningData));
        // });
        break;
    }
  };

  return (
    <React.Fragment>
      <Box sx={{ height: "100%" }}>
        <Box className="actionWrapper" sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <SwitchButton
            label="Show all actions"
            isOn={showAllctions}
            handleOnClick={() => setShowAllActions(!showAllctions)}
          />
          <Button
            className="addActionButton"
            disableElevation
            variant="contained"
            size="small"
            startIcon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => manageAddAction()}
            disabled={addAction}
          >
            {"Add Action"}
          </Button>
        </Box>
        <Box sx={{ height: "calc(100% - 62px)" }}>
          <ActionsTable
            data={
              !isAdmin && module == "licence"
                ? actionList?.filter(
                    (d: any) =>
                      (d?.isCreatedByJL && d?.licenceJLActionStatus) ||
                      !d?.isCreatedByJL
                  )
                : actionList
            }
            head={tableHead}
            isAction={true}
            addAction={addAction}
            isLoading={isFetchingActions}
            isAddLoading={isAddAcionLoad}
            bg={"#FFFFFF"}
            handleClick={() => setAddAction(false)}
            manageCRUD={manageCRUDMethod}
            module={module}
            initialNewAction={
              isAdmin && module == "licence" ? initialAdminAction : null
            }
          />
        </Box>
      </Box>
    </React.Fragment>
  );
};
